import bankStyles from '../../assets/css/banks.module.css';
import SearchIcon from '../svgs/SearchIcon';
import { TextField } from '@mui/material';
import { ChangeEvent, Ref, useState } from 'react';
import { useDebounce } from '../../utils/useDebounce';
import { selectPrimaryColor } from '../../app/slices/configuration.slice';
import { SEARCH_PREFIX } from '../../utils/translationPagePrefix';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';

const inputSX = {
	width: '100%',
	paddingRight: '15px',
	borderBottom: 'none'
};

interface BankSearchProps {
	inputRef?: Ref<HTMLInputElement>;
	onSearchChange(value: string): void;
}

const BankSearch = ({ inputRef, onSearchChange }: BankSearchProps) => {
	const { t } = useTranslation();

	const [searchValue, setSearchValue] = useState<string>('');
	const debouncedOnSearchChange = useDebounce(onSearchChange, 500, onSearchChange);

	const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setSearchValue(value);
		debouncedOnSearchChange(value);
	};

	const placeholder = t(`${SEARCH_PREFIX}.placeholder`);
	const primaryColor = useAppSelector(selectPrimaryColor);
	const [hover, setHover] = useState(false);

	const sectionStyle = {
		borderRadius: hover ? '100px' : undefined,
		boxShadow: hover ? `0 1px 4px 0 ${primaryColor}` : undefined
	};

	return (
		<div
			className={bankStyles['search-container']}
			style={sectionStyle}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
		>
			<div className={bankStyles['search-icon-container']}>
				<SearchIcon />
			</div>
			<div className={bankStyles['search-input-container']}>
				<TextField
					id="banks-search-input"
					variant="standard"
					placeholder={placeholder}
					className="search-input-c"
					sx={inputSX}
					InputProps={{ disableUnderline: true }}
					inputRef={inputRef}
					value={searchValue}
					onChange={onChange}
				/>
			</div>
		</div>
	);
};

export default BankSearch;
